/**
 * Created by Ivan on 05.02.2026
 */

let LevelMasteryWindow;

switch (cleverapps.config.ui) {
    case "riddles":
        LevelMasteryWindow = RiddlesLevelMasteryWindow;
        break;
}